import { FirebaseEventManager } from 'frontend-share-components';

const firebaseEventManager = new FirebaseEventManager();

export default class EventManager {
  static setUserProperties(uniqueId, isFree = true) {
    firebaseEventManager.setUserProperties({ uniqueId, isFree })
  }

  static sendEvent (eventAction, params = {}) {
    const obj = firebaseEventManager.stringifyValue({
      event_action: eventAction,
      ...params,
    });
    firebaseEventManager.logEvent('user_feedback', obj);
  }

  static enterFeedbackForm () {
    EventManager.sendEvent('enter feedback form');
  }

  static clickSearchBarSend = false;
  static clickSearchBar () {
    if (!EventManager.clickSearchBarSend) {
      EventManager.sendEvent('click search bar');
      EventManager.clickSearchBarSend = true;
    }
  }

  static categoryId = null;
  static clickCategory (id) {
    EventManager.categoryId = id;
    EventManager.sendEvent('click category', { category: id });
  }

  static secondaryCategoryId = null;
  static clickSecondaryCategory (id) {
    EventManager.secondaryCategoryId = id;
    EventManager.sendEvent('click secondary category', { category: EventManager.categoryId, secondary_category: id });
  }

  static subcategoryId = null;
  static clickSubcategory (id, articleId) {
    EventManager.subcategoryId = id;
    EventManager.sendEvent('click subcategory', {
      category: EventManager.categoryId,
      secondary_category: EventManager.secondaryCategoryId,
      subcategory: id,
      faq: articleId
    });
  }
  
  static clickMore (articleId) {
    EventManager.sendEvent('click more', {
      category: EventManager.categoryId,
      secondary_category: EventManager.secondaryCategoryId,
      subcategory: EventManager.subcategoryId,
      faq: articleId
    });
  }

  static faqId = null;
  static clickYes (id) {
    EventManager.faqId = id;
    EventManager.sendEvent('click yes', {
      category: EventManager.categoryId,
      secondary_category: EventManager.secondaryCategoryId,
      subcategory: EventManager.subcategoryId,
      faq: id
    });
  }

  static clickSystemLog () {
    EventManager.sendEvent('click system log', {
      category: EventManager.categoryId,
      secondary_category: EventManager.secondaryCategoryId,
      subcategory: EventManager.subcategoryId,
      faq: EventManager.faqId,
    });
  }

  static clickSend (ticketId, systemLogReceived) {
    const obj = {
      category: EventManager.categoryId,
      secondary_category: EventManager.secondaryCategoryId,
      subcategory: EventManager.subcategoryId,
      faq: EventManager.faqId,
      ticket: ticketId
    };
    if (typeof systemLogReceived === 'boolean') {
      obj.receive_system_log = systemLogReceived;
    }
    EventManager.sendEvent('click send', obj);
  }
}